import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import NewSeltterForm from "src/modules/NewsletterSubscribe/NewSeltterForm";

const NewsletterSubscribeMain = () => {
  return (
    <div className="flex justify-center items-center py-16 bg-gray-50">
      <div className="w-[400px] p-4 bg-white rounded-md">
        <div className="text-lg text-primary uppercase">Subscribe Newsletter </div>
        <div className="h-0.5 bg-primary w-[50px] rounded-full"></div>
        <div className="my-4 text-xs text-gray-400">
          Please fill the form below to Subscribe Newsletter and get in touch with you.
        </div>
        <NewSeltterForm />
      </div>
    </div>
  );
};

export default NewsletterSubscribeMain;
